module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "numbox",
    attrs: {
      "id": "number-box"
    }
  }, _vm._l((_vm.numArr), function(item, index) {
    var _obj;

    return _c('p', {
      staticClass: "number ",
      class: ( _obj = {}, _obj[_vm.numberData[_vm.numberData.length - (index + 1)].class] = true, _obj ),
      attrs: {
        "id": "lakh"
      }
    }, [_c('span', {
      staticClass: "num"
    }, [_vm._v("0")]), _vm._v(" "), _c('span', {
      staticClass: "num"
    }, [_vm._v("1")]), _vm._v(" "), _c('span', {
      staticClass: "num"
    }, [_vm._v("2")]), _vm._v(" "), _c('span', {
      staticClass: "num"
    }, [_vm._v("3")]), _vm._v(" "), _c('span', {
      staticClass: "num"
    }, [_vm._v("4")]), _vm._v(" "), _c('span', {
      staticClass: "num"
    }, [_vm._v("5")]), _vm._v(" "), _c('span', {
      staticClass: "num"
    }, [_vm._v("6")]), _vm._v(" "), _c('span', {
      staticClass: "num"
    }, [_vm._v("7")]), _vm._v(" "), _c('span', {
      staticClass: "num"
    }, [_vm._v("8")]), _vm._v(" "), _c('span', {
      staticClass: "num"
    }, [_vm._v("9")])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a62eaa18"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/numscroll/NumScroll.vue
// module id = 9ic9
// module chunks = 1